import { Component } from '@angular/core';
import { NonNullableFormBuilder, Validators } from '@angular/forms';
import { DocumentFormBase } from '../document-form.base';
import { dateValiditePjErrors } from '@lib/validators/date-validition-pj-errors-validators';
import { OuiDatePicker, OuiValidationError } from 'omnium-ui/form-field';

@Component({
  selector: 'app-document-form-cerfa-3558',
  standalone: true,
  imports: [OuiDatePicker],
  templateUrl: './document-form-cerfa-3558.component.html',
  styleUrl: './document-form-cerfa-3558.component.scss',
})
export class DocumentFormCerfa3558Component extends DocumentFormBase<Cerfa3558Form> {
  readonly dateValidationErrors: OuiValidationError[] = dateValiditePjErrors();

  override createForm(fb: NonNullableFormBuilder) {
    return createCerfa3558Form(fb);
  }

  setDateFinDeValidite(newDate: moment.Moment | string | null) {
    if (newDate != null && typeof newDate != 'string') {
      this.form.get('dateFinValidite')?.setValue(undefined);
    }
  }
}

export function createCerfa3558Form(fb: NonNullableFormBuilder) {
  return fb.group({
    dateDebutValidite: fb.control<Date | undefined>(undefined, [Validators.required]),
    dateFinValidite: fb.control<Date | undefined>(undefined),
  });
}

export type Cerfa3558Form = ReturnType<typeof createCerfa3558Form>;
export type Cerfa3558FormValue = Cerfa3558Form['value'];
